"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsHighchartsComponent = exports.eventsChartIdentifier = void 0;
const React = __importStar(require("react"));
const EventsPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPageDataProvider");
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const HighchartsComponentWrapper_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsComponentWrapper");
exports.eventsChartIdentifier = "events";
exports.EventsHighchartsComponent = React.memo(() => {
    const highchartsOptionsContext = (0, HighchartsOptionsProvider_1.useHighchartsOptionsContext)();
    const eventsPageDataContext = (0, EventsPageDataProvider_1.useEventsPageDataContext)();
    // if (!!process.env.IS_TEST_SERVER) {
    //     console.log("EventsHighchartsComponent: eventsPageDataContext", eventsPageDataContext);
    // }
    const inProgress = eventsPageDataContext.state.inProgress;
    return React.createElement(HighchartsComponentWrapper_1.HighchartsComponentWrapper, { highchartsOptionsState: highchartsOptionsContext.state, inProgress: inProgress, chartIdentifier: exports.eventsChartIdentifier });
});
exports.EventsHighchartsComponent.displayName = "EventsHighchartsComponent";
